import { mean, round } from "lodash-es";

/**
 * Computes the average (mean) of the values in array, rounded to the given precision.
 *
 * @category Math
 * @param values The array of numbers to average together.
 * @param precision The number of decimal places to round to. Defaults to 1.
 */
export function averageAndRound(values: number[], precision: number = 1) {
  return round(mean(values), precision);
}
